<template>
  <div class="platformMaintenance">
    <div class="management-search">
      <div class="management-search-1">
        模板：
        <a-select
          v-model="modelId"
          placeholder="请选择模板"
          class="select-tag"
          @change="getList"
        >
          <a-select-option
            v-for="(item, index) in modelList"
            :key="item.id"
            :value="item.id"
          >
            <span :style="{ color: item.enabled ? 'green' : 'grey' }">{{
              item.name
            }}</span>
          </a-select-option>
        </a-select>
      </div>
      <div class="management-search-1">
        名称：
        <a-input
          placeholder="请输入名称"
          v-model="name"
          @keyup.enter="getList()"
          allow-clear
        ></a-input>
      </div>
      <div class="management-search-1">
        平台：
        <a-select
          v-model="platformId"
          placeholder="请选择平台"
          class="select-tag"
          @change="getList"
        >
          <a-select-option
            v-for="(item, index) in platformSelectList"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </div>
    </div>
    <div style="width: 60%; margin-bottom: 20px">
      <a-checkbox v-model="enabled" @change="getList()">是否启用</a-checkbox>
      <a-tooltip placement="topLeft">
        <template slot="title">变更排序</template>
        <a-button
          type="link"
          @click.stop="sortVisible = true"
          style="float: right; padding: 0 10px"
        >
          <icon-font type="icon-paixu" style="font-size: 18px"></icon-font>
        </a-button>
      </a-tooltip>
      <a-tooltip placement="topLeft">
        <template slot="title">添加label</template>
        <a-button
          type="link"
          @click.stop="addLabel"
          style="float: right; padding: 0 10px"
        >
          <icon-font type="icon-jia" style="font-size: 18px"></icon-font>
        </a-button>
      </a-tooltip>
      <a-tooltip placement="topLeft">
        <template slot="title">预览</template>
        <a-button
          type="link"
          @click.stop="previewVisible = true"
          style="float: right; padding: 0 10px"
        >
          <icon-font type="icon-yanjing" style="font-size: 18px"></icon-font>
        </a-button>
      </a-tooltip>
    </div>
    <div v-for="item in list" :key="item.id" class="label">
      <div class="header">
        {{ item.id }}
        <a-input v-model="item.name"></a-input>
        <a-button
          type="link"
          v-if="item.name !== item.oldName"
          @click="saveName(item)"
          >保存</a-button
        >
        <a-dropdown style="float: right">
          <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
            <a-icon type="ellipsis" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-if="item.type == 'OPTION'">
              <a href="javascript:;" @click="addOption(item.id)">添加选项</a>
            </a-menu-item>
            <a-menu-item v-if="item.type == 'OPTION'">
              <a href="javascript:;" @click="defaultOption(item)"
                >设置默认选项</a
              >
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;" @click="changeLabelType(item)"
                >变更问题类型</a
              >
            </a-menu-item>
            <a-menu-item>
              <a-popconfirm
                placement="right"
                okText="确认"
                cancelText="取消"
                @confirm="deleteLabel(item)"
              >
                <template slot="title">是否确认删除</template>
                <a href="javascript:;" style="color: #ff4d4f">删除</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-switch
          v-model="item.enabled"
          checkedChildren="已启用"
          unCheckedChildren="已禁用"
          style="float: right; margin-right: 10px"
          @change="enabledChange($event, item.id)"
        />
      </div>
      <div class="main" v-if="item.qualificationOptionList">
        <div class="optionsHeader">
          <div style="margin-left: 30px; width: 40px">编号</div>
          <div style="width: 240px">选项</div>
          <div style="margin-left: 10px; width: 50px">排序</div>
          <div style="margin-left: 10px">提交值</div>
        </div>
        <div class="options" v-for="options in item.qualificationOptionList">
          <a-tooltip placement="topLeft">
            <template slot="title"> 默认选项 </template>
            <icon-font
              type="icon-moren"
              style="font-size: 16px; color: #000"
              v-if="options.defaultOption"
            ></icon-font>
          </a-tooltip>
          <a-tooltip placement="topLeft">
            <template slot="title"> 默认随机选项, 随机选一个 </template>
            <icon-font
              type="icon-suijibofang"
              style="font-size: 16px; color: #000"
              v-if="options.randomOption"
            ></icon-font>
          </a-tooltip>
          <span
            v-if="!options.defaultOption && !options.randomOption"
            style="display: inline-block; width: 16px"
          ></span>
          <span style="display: inline-block; width: 40px; margin-left: 14px">
            {{ options.id }}
          </span>
          <a-input v-model="options.content"></a-input>
          <a-input v-model="options.order" class="order"></a-input>
          <a-input v-model="options.value" class="value"></a-input>
          <a-popconfirm
            placement="right"
            okText="确认"
            cancelText="取消"
            @confirm="deleteOption(options.id)"
          >
            <template slot="title">是否确认删除</template>
            <a href="javascript:;" style="color: #ff4d4f; margin-left: 15px"
              >删除</a
            >
          </a-popconfirm>
          <a-button type="link" @click="incidenceRelation(item, options)"
            >关联关系</a-button
          >
          <a-button
            type="link"
            v-if="
              options.stitchingValue !==
              options.content + options.order + options.value
            "
            @click="saveOption(options)"
            >保存</a-button
          >
        </div>
      </div>
      <div class="main" v-else-if="item.type == 'NUMBER'">
        <div class="options">
          <span style="display: inline-block; width: 16px"></span>
          <a-input placeholder="手动输入" disabled></a-input>
          <a-button type="link" @click="incidenceRelation(item)"
            >关联关系</a-button
          >
        </div>
      </div>
      <div class="main" v-else-if="item.isCity">
        <div class="options">
          <span style="display: inline-block; width: 16px"></span>
          <a-input placeholder="城市选择" disabled></a-input>
          <a-button type="link" @click="incidenceRelation(item)"
            >关联关系</a-button
          >
        </div>
      </div>
      <div class="main" v-if="item.hideInfo" style="margin-top: 5px">
        <a-icon type="info-circle" />&nbsp;&nbsp; 如果
        <b style="color: #000">{{ item.hideInfo }}</b> 被选中, 该问题将不会展现
      </div>
    </div>
    <a-drawer
      title="关联关系"
      placement="right"
      :visible="visible"
      width="1000px"
      @close="onClose"
      :zIndex="2"
    >
      <h3>{{ title }}</h3>
      <div style="margin: 10px 0">
        <a-button type="primary" @click="addIncidenceRelation">新增</a-button>
      </div>
      <a-table
        :columns="tableColumns"
        :dataSource="tableDataSource"
        :pagination="false"
        :loading="loadingTable"
        size="middle"
        :rowKey="(record) => record.id"
      >
        <span slot="type" slot-scope="text, record, index">
          <a-select
            v-model="record.type"
            style="width: 200px"
            @change="typeChange(index)"
          >
            <a-select-option
              v-for="(item, index) in optionTypeList"
              :key="index"
              :value="item.type"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </span>
        <span slot="value" slot-scope="text, record">
          <span
            v-if="
              record.type == 'OPTION' ||
              record.type == 'LABEL' ||
              record.type == 'RANDOM_OPTION'
            "
            >{{ text }}</span
          >
          <a-input v-model="record.value" style="width: 160px" v-else></a-input>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-button
            type="link"
            @click="saveValue(record)"
            :disabled="
              record.value == record.oldValue && record.type == record.oldType
            "
            style="padding: 0"
            >保存</a-button
          >
          <a-divider type="vertical" />
          <a-popconfirm
            placement="right"
            okText="确认"
            cancelText="取消"
            @confirm="deleteClick(record)"
          >
            <template slot="title">是否确认删除{{ record.name }}</template>
            <a href="javascript:;" style="color: #ff4d4f">删除</a>
          </a-popconfirm>
        </span>
      </a-table>
      <template v-if="platformOptionId">
        <h3 style="margin: 20px 0">
          隐藏信息列表&nbsp;&nbsp;
          <a-button type="primary" @click="addHideInfo">新增</a-button>
        </h3>
        <a-table
          :columns="hideInfoColumns"
          :dataSource="hideInfoDataSource"
          :pagination="false"
          :loading="loadingTable"
          size="middle"
          :rowKey="(record) => record.id"
        >
          <span slot="action" slot-scope="text, record">
            <a-popconfirm
              placement="right"
              okText="确认"
              cancelText="取消"
              @confirm="deleteHideInfo(record)"
            >
              <template slot="title">是否确认删除{{ record.name }}</template>
              <a href="javascript:;" style="color: #ff4d4f">删除</a>
            </a-popconfirm>
          </span>
        </a-table>
      </template>
    </a-drawer>
    <a-modal
      title="新增关联关系"
      v-model="addVisible"
      :maskClosable="false"
      class="action-class"
      width="500px"
      :zIndex="3"
    >
      <a-form>
        <a-form-item
          label="label:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select
            v-model="labelIdAdd"
            placeholder="请选择label"
            class="select-tag"
            allowClear
            show-search
            @search="getLabelList"
            :filter-option="false"
          >
            <a-select-option
              v-for="item in labelList"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="option:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select
            v-model="optionIdListAdd"
            placeholder="请选择option"
            class="select-tag"
            allowClear
            :disabled="!labelIdAdd"
            show-search
            option-filter-prop="children"
            :filter-option="filterOption"
            mode="multiple"
          >
            <a-select-option
              v-for="item in optionList"
              :key="item.id"
              :value="item.id"
              >{{ item.content }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="addVisible = false">关闭</a-button>
          <a-button type="primary" @click="add_submit">确认</a-button>
        </div>
      </template>
    </a-modal>
    <a-modal
      title="新增选项"
      v-model="addOptionVisible"
      :maskClosable="false"
      class="action-class"
      width="500px"
      :zIndex="3"
    >
      <a-form>
        <a-form-item
          label="选项:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input v-model="optionAdd" placeholder="请输入选项"></a-input>
        </a-form-item>
        <a-form-item
          label="提交值:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input v-model="value" placeholder="请输入提交值"></a-input>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="addOptionVisible = false">关闭</a-button>
          <a-button type="primary" @click="addOption_submit">确认</a-button>
        </div>
      </template>
    </a-modal>
    <a-modal
      title="变更问题类型"
      v-model="changeLabelVisible"
      :maskClosable="false"
      class="action-class"
      width="500px"
      :zIndex="3"
    >
      <a-form>
        <a-form-item
          label="类型:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select
            v-model="labelType"
            placeholder="请选择label"
            class="select-tag"
            allowClear
          >
            <a-select-option
              v-for="(item, index) in labelTypeList"
              :key="index"
              :value="item.type"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="changeLabelVisible = false"
            >关闭</a-button
          >
          <a-button type="primary" @click="changeLabel_submit">确认</a-button>
        </div>
      </template>
    </a-modal>
    <a-modal
      title="修改排序"
      v-model="sortVisible"
      :maskClosable="false"
      class="action-class"
      width="800px"
      :zIndex="3"
    >
      <a-table
        :columns="sortColumns"
        :dataSource="sortList"
        :pagination="false"
        size="small"
        :rowKey="(record) => record.id"
        :customRow="customRow"
      ></a-table>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="sortVisible = false">关闭</a-button>
          <a-button type="primary" @click="sort_submit">确认</a-button>
        </div>
      </template>
    </a-modal>
    <a-modal
      title="新增问题"
      v-model="addLabelVisible"
      :maskClosable="false"
      class="action-class"
      width="500px"
      :zIndex="3"
    >
      <a-form>
        <a-form-item
          label="名称:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input v-model="labelAdd" placeholder="请输入名称"></a-input>
        </a-form-item>
        <a-form-item
          label="类型:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select
            v-model="labelTypeAdd"
            placeholder="请选择label"
            class="select-tag"
          >
            <a-select-option
              v-for="(item, index) in labelTypeList"
              :key="index"
              :value="item.type"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="字段:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input v-model="field" placeholder="请输入字段"></a-input>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="addLabelVisible = false">关闭</a-button>
          <a-button type="primary" @click="addLabel_submit">确认</a-button>
        </div>
      </template>
    </a-modal>

    <a-modal
      title="新增隐藏信息"
      v-model="addHideInfoVisible"
      :maskClosable="false"
      class="action-class"
      width="500px"
      :zIndex="3"
    >
      <a-form>
        <a-form-item
          label="label:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select
            v-model="labelIdAdd"
            placeholder="请选择label"
            class="select-tag"
            allowClear
            show-search
            @search="getList"
            :filter-option="false"
          >
            <a-select-option
              v-for="item in list"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="addHideInfoVisible = false"
            >关闭</a-button
          >
          <a-button type="primary" @click="addHideInfo_submit">确认</a-button>
        </div>
      </template>
    </a-modal>

    <a-modal
      title="默认选项"
      v-model="defaultVisible"
      :maskClosable="false"
      class="action-class"
      width="500px"
      :zIndex="3"
    >
      <a-form>
        <a-form-item
          label="类型:"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 17 }"
        >
          <a-select
            v-model="defaultType"
            placeholder="请选择类型"
            class="select-tag"
          >
            <a-select-option
              v-for="(item, index) in typeList"
              :key="index"
              :value="item.type"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="默认值:"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 17 }"
          v-if="defaultType !== ''"
        >
          <a-radio-group
            v-model="defaultValue"
            v-if="defaultType == 'DEFAULT_OPTION'"
          >
            <template v-for="item in optionList">
              <a-radio :value="item.id"> {{ item.content }} </a-radio><br />
            </template>
          </a-radio-group>
          <a-checkbox-group v-model="defaultValueArr" v-else>
            <template v-for="item in optionList">
              <a-checkbox :value="item.id"> {{ item.content }} </a-checkbox
              ><br />
            </template>
          </a-checkbox-group>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="defaultVisible = false">关闭</a-button>
          <a-button type="primary" @click="defaultOption_submit">确认</a-button>
        </div>
      </template>
    </a-modal>

    <a-modal
      title="预览"
      v-model="previewVisible"
      :maskClosable="false"
      class="preview"
      width="700px"
      :zIndex="3"
    >
      <a-table
        :columns="columns"
        :dataSource="list"
        :pagination="false"
        :rowKey="(record) => record.id"
        bordered
      >
        <span slot="qualificationOptionList" slot-scope="text, record">
          <template v-if="text">
            <template v-for="(item, index) in text">
              <span
                :style="{
                  borderTop: index == 0 ? 'none' : '1px solid rgba(0,0,0,0.3)',
                  display: 'inline-block',
                  width: '100%',
                }"
              >
                {{ item.content }} </span
              ><br />
            </template>
          </template>
        </span>
      </a-table>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="previewVisible = false">关闭</a-button>
        </div>
      </template>
    </a-modal>
  </div>
</template>

<script>
import api from "../lib/formMaintenance.js";
import stateStatisticsApi from "../lib/stateStatistics.js";

export default {
  name: "platformMaintenance",
  data() {
    return {
      list: [],
      platformId: undefined,
      platformSelectList: [],
      visible: false,
      addVisible: false,
      platformOptionId: null,
      loadingTable: false,
      tableColumns: [
        {
          title: "编号",
          dataIndex: "id",
        },
        {
          title: "系统label",
          dataIndex: "labelName",
        },
        {
          title: "系统option",
          dataIndex: "optionName",
        },
        {
          title: "类型",
          dataIndex: "type",
          width: 240,
          scopedSlots: { customRender: "type" },
        },
        {
          title: "value",
          dataIndex: "value",
          width: 240,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      tableDataSource: [],
      loadingTable: false,
      platformLabelId: null,
      labelIdAdd: undefined,
      optionIdListAdd: [],
      optionList: [],
      labelList: [],
      addOptionVisible: false,
      optionAdd: "",
      labelAdd: "",
      labelId: "",
      name: "",
      title: "",
      optionTypeList: [
        { type: "OPTION", name: "选项一对一" },
        { type: "RANDOM_OPTION", name: "平台随机选项" },
        { type: "RANDOM_THOUSAND_DOWN", name: "千位随机向下取整" },
        { type: "LABEL", name: "输入一对一" },
        { type: "DEFAULT_VALUE", name: "传递默认值" },
      ],
      changeLabelVisible: false,
      labelType: "",
      labelTypeList: [
        { type: "OPTION", name: "选项" },
        { type: "NUMBER", name: "输入框" },
      ],
      sourceObj: null,
      targetObj: null,
      sourceIndex: null,
      targetIndex: null,
      sortVisible: false,
      sortColumns: [
        {
          title: "编号",
          dataIndex: "id",
        },
        {
          title: "类型",
          dataIndex: "type",
          customRender: (text, row, index) => {
            if (text == "OPTION") {
              return {
                children: <span>选项</span>,
              };
            } else if (text == "NUMBER") {
              return {
                children: <span>输入框</span>,
              };
            }
          },
        },
        {
          title: "名称",
          dataIndex: "name",
        },
        {
          title: "隐藏信息",
          dataIndex: "hideInfo",
        },
      ],
      sortList: [],
      addLabelVisible: false,
      field: "",
      labelTypeAdd: undefined,
      hideInfoColumns: [
        {
          title: "编号",
          dataIndex: "id",
        },
        {
          title: "名称",
          dataIndex: "name",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      hideInfoDataSource: [],
      addHideInfoVisible: false,
      labelIdHideInfoAdd: "",
      typeList: [
        { type: "", name: "无" },
        { type: "DEFAULT_OPTION", name: "默认选项" },
        { type: "RANDOM_OPTION", name: "随机选项" },
      ],
      defaultType: undefined,
      defaultValueArr: [],
      defaultValue: "",
      defaultVisible: false,
      optionList: [],
      enabled: true,
      previewVisible: false,
      columns: [
        {
          title: "编号",
          width: 60,
          align: "center",
          dataIndex: "id",
        },
        {
          title: "问题",
          width: 200,
          align: "center",
          dataIndex: "name",
        },
        {
          title: "选项",
          dataIndex: "qualificationOptionList",
          align: "center",
          scopedSlots: { customRender: "qualificationOptionList" },
        },
      ],
      value: "",
      modelList: [],
      modelId: undefined,
    };
  },
  watch: {
    labelIdAdd: {
      handler(newVal) {
        this.labelList.forEach((item) => {
          if (newVal == item.id && item.loanQualificationOptionList) {
            this.optionList.splice(0);
            this.optionList.push(...item.loanQualificationOptionList);
          }
        });
      },
    },
  },
  created() {
    this.getModelList();
  },
  methods: {
    getModelList() {
      api.list().then((res) => {
        if (res.result == 200) {
          this.modelList = res.data;
          for (let index = 0; index < this.modelList.length; index++) {
            if (this.modelList[index].enabled) {
              this.modelId = this.modelList[index].id;
              break;
            }
          }
          this.getPlatformSelectList();
          this.getLabelList();
        }
      });
    },
    typeChange(index) {
      this.$set(this.tableDataSource[index], "value", "");
    },
    defaultOption_submit() {
      let data = {
        labelId: this.labelId,
        defaultType: this.defaultType,
        defaultValue: "",
      };
      if (this.defaultType == "") {
        data.defaultValue = "";
      } else if (this.defaultType == "DEFAULT_OPTION") {
        data.defaultValue = this.defaultValue + "";
      } else {
        data.defaultValue = this.defaultValueArr.join(",");
      }
      api.modifyPlatformLabelDefaultValue(data).then((res) => {
        if (res.result == 200) {
          this.$message.success("设置成功");
          this.getList();
          this.defaultVisible = false;
        }
      });
    },
    defaultOption(val) {
      this.labelId = val.id;
      this.defaultType = val.defaultType;
      if (this.defaultType == "") {
        this.defaultValue = "";
      } else if (this.defaultType == "DEFAULT_OPTION") {
        this.defaultValue = val.defaultValue * 1;
      } else {
        this.defaultValueArr = val.defaultValue.split(",");
        this.defaultValueArr.forEach((item, index) => {
          this.defaultValueArr[index] = item * 1;
        });
      }
      this.optionList = val.qualificationOptionList;
      this.defaultVisible = true;
    },
    addHideInfo_submit() {
      let data = {
        optionId: this.platformOptionId,
        labelId: this.labelIdHideInfoAdd,
        platformId: this.platformId,
        modelId: this.modelId,
      };
      api.addPlatformHideInfo(data).then((res) => {
        if (res.result == 200) {
          this.$message.success("添加成功");
          this.incidenceRelation();
          this.addHideInfoVisible = false;
        }
      });
    },
    deleteHideInfo(val) {
      api.deletePlatformHideInfo({ id: val.id }).then((res) => {
        if (res.result == 200) {
          this.$message.success("删除成功");
          this.incidenceRelation();
        }
      });
    },
    addHideInfo() {
      this.labelIdHideInfoAdd = undefined;
      this.addHideInfoVisible = true;
    },
    addLabel() {
      this.labelAdd = "";
      this.labelTypeAdd = "OPTION";
      this.field = "";
      this.addLabelVisible = true;
    },
    addLabel_submit() {
      let data = {
        name: this.labelAdd,
        type: this.labelTypeAdd,
        field: this.field,
        platformId: this.platformId,
        modelId: this.modelId,
      };
      api.addPlatformLabel(data).then((res) => {
        if (res.result == 200) {
          this.$message.success("添加成功");
          this.getList();
          this.addLabelVisible = false;
        }
      });
    },
    sort_submit() {
      let sortedIdList = [];
      this.sortList.forEach((item) => {
        sortedIdList.push(item.id);
      });
      let data = {
        sortedIdList,
        system: false,
      };
      api.saveLabelOrder(data).then((res) => {
        if (res.result == 200) {
          this.$message.success("修改排序成功");
          this.sortVisible = false;
          this.getList();
        }
      });
    },
    customRow(record, index) {
      return {
        style: {
          cursor: "pointer",
        },
        on: {
          // 鼠标移入
          mouseenter: (event) => {
            // 兼容IE
            var ev = event || window.event;
            ev.target.draggable = true;
          },
          // 开始拖拽
          dragstart: (event) => {
            // 兼容IE
            var ev = event || window.event;
            // 阻止冒泡
            ev.stopPropagation();
            // 得到源目标数据
            this.sourceObj = record;
            this.sourceIndex = index;
          },
          // 拖动元素经过的元素
          dragover: (event) => {
            // 兼容 IE
            var ev = event || window.event;
            // 阻止默认行为
            ev.preventDefault();
          },
          // 鼠标松开
          drop: (event) => {
            // 兼容IE
            var ev = event || window.event;
            // 阻止冒泡
            ev.stopPropagation();
            // 得到目标数据
            this.targetObj = record;
            this.targetIndex = index;
            if (this.sourceObj.id !== this.targetObj.id) {
              this.sortList.splice(this.sourceIndex, 1);
              this.sortList.splice(this.targetIndex, 0, this.sourceObj);
            }
            this.targetObj = null;
            this.sourceObj = null;
            this.sourceIndex = null;
            this.targetIndex = null;
          },
        },
      };
    },
    changeLabel_submit() {
      let data = {
        id: this.labelId,
        type: this.labelType,
        modelId: this.modelId,
      };
      api.changePlatformLabelType(data).then((res) => {
        if (res.result == 200) {
          this.$message.success("修改成功");
          this.getList();
          this.changeLabelVisible = false;
        }
      });
    },
    saveValue(val) {
      let data = {
        id: val.id,
        type: val.type,
        value: val.value,
        labelId: val.labelId,
        optionId: val.optionId,
        platformId: this.platformId,
        platformLabelId: this.platformLabelId,
        platformOptionId: this.platformOptionId,
        modelId: this.modelId,
      };
      api.modifyBindRelation(data).then((res) => {
        if (res.result == 200) {
          this.$message.success("添加成功");
          this.incidenceRelation();
          this.addVisible = false;
        }
      });
    },
    changeLabelType(val) {
      this.labelId = val.id;
      this.labelType = val.type;
      this.changeLabelVisible = true;
    },
    addOption(labelId) {
      this.labelId = labelId;
      this.optionAdd = "";
      this.addOptionVisible = true;
    },
    addOption_submit() {
      let data = {
        labelId: this.labelId,
        content: this.optionAdd,
        value: this.value,
        enabled: true,
        modelId: this.modelId,
      };
      api.addPlatformLabelOption(data).then((res) => {
        if (res.result == 200) {
          this.$message.success("添加成功");
          this.getList();
          this.addOptionVisible = false;
        }
      });
    },
    deleteOption(id) {
      api.deletePlatformLabelOption({ id }).then((res) => {
        if (res.result == 200) {
          this.$message.success("删除成功");
          this.getList();
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    add_submit() {
      let data = {
        type: "OPTION",
        labelId: this.labelIdAdd,
        optionIdList: this.optionIdListAdd,
        platformId: this.platformId,
        platformLabelId: this.platformLabelId,
        platformOptionId: this.platformOptionId,
        modelId: this.modelId,
      };
      api.addBindRelation(data).then((res) => {
        if (res.result == 200) {
          this.$message.success("添加成功");
          this.incidenceRelation();
          this.addVisible = false;
        }
      });
    },
    addIncidenceRelation() {
      this.labelIdAdd = undefined;
      this.optionIdListAdd = [];
      this.addVisible = true;
    },
    getLabelList(name) {
      api
        .listSystemQualification({ name, modelId: this.modelId })
        .then((res) => {
          if (res.result == 200) {
            this.labelList.splice(0);
            this.labelList.push(...res.data);
          }
        });
    },
    deleteClick(val) {
      api
        .cleanBindInfo({ id: val.id, platformOptionId: this.platformOptionId })
        .then((res) => {
          if (res.result == 200) {
            this.$message.success("删除成功");
            this.incidenceRelation();
          }
        });
    },
    deleteLabel(val) {
      api.deletePlatformLabel({ id: val.id }).then((res) => {
        if (res.result == 200) {
          this.$message.success("删除成功");
          this.getList();
        }
      });
    },
    enabledChange(enabled, id) {
      api.modifyPlatformLabelEnabled({ id, enabled }).then((res) => {
        if (res.result == 200) {
          if (enabled) {
            this.$message.success("启用成功");
          } else {
            this.$message.success("禁用成功");
          }
          this.getList();
        }
      });
    },
    saveName(val) {
      api
        .modifyPlatformLabelName({ id: val.id, name: val.name })
        .then((res) => {
          if (res.result == 200) {
            this.$message.success("修改成功");
            this.$set(val, "oldName", val.name);
          }
        });
    },
    saveOption(val) {
      api
        .modifyPlatformLabelOption({
          id: val.id,
          content: val.content,
          order: val.order,
          value: val.value,
        })
        .then((res) => {
          if (res.result == 200) {
            this.$message.success("修改成功");
            this.$set(
              val,
              "stitchingValue",
              val.content + val.order + val.value
            );
          }
        });
    },
    onClose() {
      this.visible = false;
      this.platformOptionId = null;
      this.platformLabelId = null;
      this.title = "";
    },
    incidenceRelation(label, option) {
      if (label) {
        this.title = label.name;
        this.platformLabelId = label.id;
      }
      if (option) {
        this.title += " | " + option.content;
        this.platformOptionId = option.id;
      }
      api
        .queryRelationOptionByPlatformOptionId({
          platformLabelId: this.platformLabelId,
          platformOptionId: this.platformOptionId,
        })
        .then((res) => {
          if (res.result == 200) {
            this.tableDataSource = res.data;
            this.tableDataSource.forEach((item) => {
              this.$set(item, "oldValue", item.value);
              this.$set(item, "oldType", item.type);
            });
            this.hideInfoDataSource.splice(0);
            if (option) {
              api
                .listPlatformHideInfo({
                  optionId: this.platformOptionId,
                  platformId: this.platformId,
                })
                .then((res) => {
                  if (res.result == 200) {
                    this.hideInfoDataSource.push(...res.data.labelList);
                    if (!this.visible) {
                      this.visible = true;
                    }
                  }
                });
            } else {
              if (!this.visible) {
                this.visible = true;
              }
            }
          }
        });
    },
    getPlatformSelectList() {
      stateStatisticsApi.platformSelectList().then((res) => {
        if (res.result == 200) {
          this.platformSelectList = res.data;
          this.platformId = this.platformSelectList[0].id;
          this.getList();
        }
      });
    },
    getList() {
      api
        .listPlatformQualification({
          name: this.name,
          platformId: this.platformId,
          enabled: this.enabled,
          modelId: this.modelId,
        })
        .then((res) => {
          if (res.result == 200) {
            this.list.splice(0);
            this.list.push(...res.data);
            this.list.forEach((item) => {
              this.$set(item, "oldName", item.name);
              if (item.qualificationOptionList) {
                item.qualificationOptionList.forEach((options) => {
                  this.$set(
                    options,
                    "stitchingValue",
                    options.content + options.order + options.value
                  );
                });
              }
            });
            this.sortList = JSON.parse(JSON.stringify(this.list));
          }
        });
    },
  },
};
</script>

<style lang="scss">
.platformMaintenance {
  padding: 10px;
  .management-search {
    position: relative;
    overflow: hidden;
    width: 60%;
    .management-search-1 {
      float: left;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    .backup {
      padding: 5px 0;
    }
    .ant-input-affix-wrapper {
      width: 240px;
    }
    input {
      width: 240px;
    }
    .ant-select {
      width: 240px;
    }
  }
  .label {
    width: 60%;
    border: 1px solid #dedede;
    background-color: #fff;
    padding: 10px;
    position: relative;
    overflow: auto;
    margin-bottom: 10px;
    // &:hover {
    //   transform: translate(-2px, -2px) scale(1.01);
    //   transition: all 0.2s;
    //   box-shadow: rgb(0 0 0 / 8%) 0px 7px 20px;
    // }
    .header {
      color: #000;
      margin-bottom: 5px;
      padding: 10px;
      background-color: #f7f7f7;
      input {
        width: 240px;
        margin-left: 10px;
      }
    }
    .main {
      background-color: #f7f7f7;
      padding: 10px 30px;
      .optionsHeader {
        display: flex;
        justify-content: left;
        flex-wrap: nowrap;
        color: #000;
        font-weight: 700;
      }
      .options {
        input {
          width: 240px;
          margin-bottom: 10px;
        }
        .order {
          width: 50px;
          margin-left: 10px;
        }
        .value {
          width: 200px;
          margin-left: 10px;
        }
      }
    }
  }
}
.preview {
  .ant-table-content,
  .ant-table,
  td,
  th,
  table {
    border-color: rgba(0, 0, 0, 0.3) !important;
  }
  td {
    padding: 0 !important;
  }
}
</style>
